<template>
    <div class="tab-pane fade show active" id="nav-Appointment" role="tabpanel" aria-labelledby="nav-Appointment-tab"
        tabindex="0">
        <div class="table-responsive dashboard-table-responsive">
            <table class="table dashboard-card-table">
                <tbody>
                    <tr v-for="item in BookingCourt" :key="item.id">
                        <td>
                            <div class="academy-info academy-coach-info">
                                <router-link to="/coaches/coach-booking" class="academy-img">
                                    <img :src="require(`@/assets/img/booking/${item.Image}`)" alt="Booking">
                                </router-link>
                                <div class="academy-content">
                                    <h6><a data-bs-toggle="modal" data-bs-target="#upcoming-court">{{item.Title}}</a>
                                    </h6>
                                    <ul>
                                        <li>{{item.Court}}</li>
                                        <li><i class="feather-clock"></i> 06:00 PM to 08:00 PM</li>
                                    </ul>
                                </div>
                            </div>
                        </td>
                        <td>Date: Tue, Jul 11</td>
                        <td>
                            <div class="academy-new-icon">
                                <router-link to="/coaches/coach-booking">
                                    <i class="feather-chevron-right"></i>
                                </router-link>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import BookingCourt from '@/assets/json/coach-booking-court.json'
export default {
    data() {
        return {
            BookingCourt: BookingCourt
        }
    },
}
</script>